exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-job-job-tsx": () => import("./../../../src/templates/job/job.tsx" /* webpackChunkName: "component---src-templates-job-job-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-story-story-tsx": () => import("./../../../src/templates/story/story.tsx" /* webpackChunkName: "component---src-templates-story-story-tsx" */)
}

